(function () {
  const container = document.getElementById('related-blogs-grid');
  if (!container) return;

  const productTags = (container.dataset.productTags || '')
    .split(',')
    .map(t => t.trim())
    .filter(Boolean);

  if (!productTags.length) {
    console.warn('No product tags found');
    return;
  }

  const SHOP = window.location.hostname;
  const TOKEN = '3f36e99abe6cde2f3554d59760701325';
  const BLOG_HANDLE = 'article';
  const LIMIT = 4;

  let found = [];
  let cursor = null;
  let hasNextPage = true;

  function fetchArticles() {
    fetch(`https://${SHOP}/api/2024-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({
        query: `
          query ($cursor: String) {
            blog(handle: "${BLOG_HANDLE}") {
              articles(first: 50, after: $cursor) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    title
                    handle
                    tags
                    image { url }
                  }
                }
              }
            }
          }
        `,
        variables: { cursor }
      })
    })
      .then(res => res.json())
      .then(res => {
        const articles = res?.data?.blog?.articles;
        if (!articles) return;

        articles.edges.forEach(({ node }) => {
          if (found.length >= LIMIT) return;
          if (node.tags.some(tag => productTags.includes(tag))) {
            found.push(node);
          }
        });

        hasNextPage = articles.pageInfo.hasNextPage;
        cursor = articles.pageInfo.endCursor;

        if (found.length < LIMIT && hasNextPage) {
          fetchArticles();
        } else {
          render();
        }
      })
      .catch(err => console.error('Blog fetch error:', err));
  }

  function render() {
    found.forEach(article => {
      container.insertAdjacentHTML(
        'beforeend',
        `
        <article class="related-blog-card">
          <a href="/blogs/${BLOG_HANDLE}/${article.handle}">
            ${article.image ? `<img src="${article.image.url}" alt="${article.title}">` : ''}
            <h3>${article.title}</h3>
          </a>
          <a class="read_more_btn" href="/blogs/${BLOG_HANDLE}/${article.handle}">Read More...</a>
        </article>
        `
      );
    });
  }

  fetchArticles();
})();